import styled from "styled-components";

export const StyledNavbar = styled.nav`
  background-color: ${({theme}) => theme.colors.basic};
  border-radius: ${({theme}) => theme.radius.medium};
  box-shadow: 0 4px 12px 0 ${({theme}) => theme.colors.default};
  left: 50%;
  margin: 40px auto;
  position: fixed;
  top: 0;
  transform: translate(-50%, 0);
  width: 1520px;
  z-index: 99;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    border-radius: ${({theme}) => theme.radius.hdMedium};
    margin: 32px auto;
    width: 1300px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    border-radius: ${({theme}) => theme.radius.normal};
    margin: 28px auto;
    width: 1140px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin: 24px auto;
    width: 960px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin: 16px auto;
    max-width: 800px;
    width: 97%;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    border-radius: 0;
    box-shadow: none;
    margin: 0 auto;
    max-width: 100%;
    width: 100%;
  }
`;

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  height: 96px;
  justify-content: space-between;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 86px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 72px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 62px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 56px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    height: 80px;
  }
`;

export const StyledLogo = styled.div`
  margin-left: 40px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-left: 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-left: 28px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-left: 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-left: 40px;
  }
`;

export const Img = styled.img`
  width: 168px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 150px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: 8px;
    width: 130px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 110px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 94px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    width: 120px;
  }
`;

export const StyledList = styled.ul`
  display: flex;
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    background-color: rgba(0, 82, 204, .15);
    border: 1px solid #ccc;
    background-color: #fff;
    position: fixed;
    width: 98%;
    top: 80px;
    left: 1%;
    > li:last-child a {
      border: none;
    }
  }
`;

export const Li = styled.li`
  margin: 0 22px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin: 0 18px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin: 0 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin: 0 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin: 0 8px;
  }
  a {
    color: ${({theme}) => theme.colors.alternate};
    display: block;
    font-family: "RubikRegular";
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      line-height: ${({theme}) => theme.lineHeight.smallerHeight};
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      border-bottom: 1px solid #ddd;
      padding: 12px 16px;
    }
    &:hover {
      color: ${({theme}) => theme.colors.secondary};
    }
    &.active {
      color: ${({theme}) => theme.colors.secondary};
      font-weight: ${({theme}) => theme.fonts.bold};
      font-family: "RubikBold";
    }
  }
`;

export const AccountSection = styled.div`
  /* @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    background-color: rgba(0, 82, 204, .15);
    border: 1px solid #ccc;
    background-color: #fff;
    padding: 10px 24px;
    position: fixed;
    width: 98%;
    top: 215px;
    top: 80px;
    left: 1%;
  } */
  button {
    margin-right: 20px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      margin-right: 16px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      margin-right: 12px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      margin-right: 10px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      margin-right: 8px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      margin-right: 16px;
    }
  }
`;

export const LoginButton = styled.button`
  color: ${({theme}) => theme.colors.primary};
  font-family: "RubikMedium";
  &:hover {
    color: ${({theme}) => theme.colors.secondary};
  }
`;

export const SignUpButton = styled.button`
  background-color: ${({theme}) => theme.colors.secondary};
  border: 2px solid ${({theme}) => theme.colors.secondary};
  color: ${({theme}) => theme.colors.basic};
  padding: 16px 38px;
  &:hover {
    background-color: ${({theme}) => theme.colors.basic};
    color: ${({theme}) => theme.colors.secondary};
  }
  span {
    font-size: inherit;
    font-family: inherit;
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 15px 30px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 12px 26px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 9px 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    border-radius: ${({theme}) => theme.radius.small};
    padding: 6px 16px;
  }
`;

export const MenuOption = styled.div`
  margin-right: 40px;
  margin-top: 10px;
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 0;
  }
  svg {
    color: ${({theme}) => theme.colors.secondary};
    cursor: pointer;
    font-size: ${({theme}) => theme.fonts.defaultSize};
    &:hover {
      color: ${({theme}) => theme.colors.primary};
    }
  }
`;
